// extracted by mini-css-extract-plugin
export default {"contactMsg":"register_contactMsg__92eJI","slideUp":"register_slideUp__8zHxo"};